import { Group, Radio, Stack, Text } from '@mantine/core'
import { useHover } from '@mantine/hooks'
import { ReactNode } from 'react'

type RadioCardProps = {
  isSelected: boolean
  value: string
  title: ReactNode
  description: ReactNode
  badge?: ReactNode
  icon?: ReactNode
}

export const RadioCard = ({
  isSelected,
  value,
  title,
  description,
  badge,
  icon
}: RadioCardProps) => {
  const { hovered, ref } = useHover()

  return (
    <Radio.Card
      ref={ref}
      value={value}
      styles={{
        card: {
          padding: 'var(--mantine-spacing-md)',
          borderColor: isSelected
            ? 'var(--mantine-primary-color-filled)'
            : 'var(--mantine-color-gray-4)',
          backgroundColor: hovered ? 'var(--mantine-color-gray-0)' : undefined,
          display: 'flex',
          alignItems: 'flex-start'
        }
      }}
    >
      <Group wrap="nowrap" align="start" justify="space-between" w="100%">
        <Group wrap="nowrap" align="start">
          <Radio.Indicator />

          <Stack gap="xs">
            <Group wrap="nowrap">
              <Text size="md" lh={1.3} fw="bold">
                {title}
              </Text>

              {badge}
            </Group>

            <Text size="sm" c="gray.7">
              {description}
            </Text>
          </Stack>
        </Group>

        {icon}
      </Group>
    </Radio.Card>
  )
}
